import { customizeError } from '@chilecompra/react-kit/errors'
import { deleteCookie, getCookie, putCookie } from '@chilecompra/react-kit/storages'
import { formatDNI } from '@chilecompra/react-kit/utils'
import { REACT_APP_API_BASE_URL, REACT_APP_FEATURE_FLAG_TAXES_KEY_CHECKS } from '../../config/settings/environment'
import { makeActionCreator } from '../../config/store/utils'
import { getTaxesKeyToken, getTaxesKeyUser } from '../../services/auth'

export const GET_TAXES_KEY_TOKEN = 'GET_TAXES_KEY_TOKEN'
export const GET_TAXES_KEY_TOKEN_ERROR = 'GET_TAXES_KEY_TOKEN_ERROR'
export const GET_TAXES_KEY_TOKEN_SUCCESS = 'GET_TAXES_KEY_TOKEN_SUCCESS'
export const onGetTaxesKeyToken = makeActionCreator(GET_TAXES_KEY_TOKEN)
export const onGetTaxesKeyTokenError = makeActionCreator(GET_TAXES_KEY_TOKEN_ERROR, 'payload')
export const onGetTaxesKeyTokenThunk = payload => async dispatch => {
  dispatch(onGetTaxesKeyToken())

  try {
    const backup = await Promise.resolve()
      .then(() => getCookie('registerWizardBackup', { base64: true, json: true }))
      .catch(() => {
        throw customizeError({ code: 400, reason: 'SOMETHING_WENT_WRONG_ERROR' })
      })
    const { data } = await getTaxesKeyToken({ code: payload.code, state: payload.csrfToken }).catch(() => {
      throw customizeError({ code: 400, originalError: backup, reason: 'SOMETHING_WENT_WRONG_ERROR' })
    })

    return dispatch(onGetTaxesKeyUserThunk({ backup, token: data.payload.access_token }))
  } catch (error) {
    const { originalError: backup, reason } = error.toObject()

    deleteCookie('registerWizardBackup')

    return dispatch(onGetTaxesKeyTokenError({ backup, reason }))
  }
}

export const GET_TAXES_KEY_USER = 'GET_TAXES_KEY_USER'
export const GET_TAXES_KEY_USER_ERROR = 'GET_TAXES_KEY_USER_ERROR'
export const GET_TAXES_KEY_USER_SUCCESS = 'GET_TAXES_KEY_USER_SUCCESS'
export const onGetTaxesKeyUser = makeActionCreator(GET_TAXES_KEY_USER)
export const onGetTaxesKeyUserError = makeActionCreator(GET_TAXES_KEY_USER_ERROR, 'payload')
export const onGetTaxesKeyUserSuccess = makeActionCreator(GET_TAXES_KEY_USER_SUCCESS, 'payload')
export const onGetTaxesKeyUserThunk = payload => async dispatch => {
  dispatch(onGetTaxesKeyUser())
  deleteCookie('registerWizardBackup')

  try {
    const { data } = await getTaxesKeyUser({ token: payload.token }).catch(() => {
      throw customizeError({ code: 400, reason: 'SOMETHING_WENT_WRONG_ERROR' })
    })
    const [entity = {}] = data.payload?.entities || []
    const formattedDNI = formatDNI(payload.backup?.business?.dni, 2)
    const taxesKeyDNI = `${entity?.rut?.base}-${entity?.rut?.dv}`.toUpperCase()
    const taxesKeyDNICheck =
      REACT_APP_FEATURE_FLAG_TAXES_KEY_CHECKS === true || REACT_APP_FEATURE_FLAG_TAXES_KEY_CHECKS === 'true'
    if (formattedDNI !== taxesKeyDNI && taxesKeyDNICheck) {
      throw customizeError({ code: 400, originalError: payload.backup, reason: 'DNI_DOES_NOT_MATCH_TAXES_KEY_ERROR' })
    }

    return dispatch(
      onGetTaxesKeyUserSuccess({
        backup: payload.backup,
        name: entity?.razonSocial
      })
    )
  } catch (error) {
    const { originalError: backup, reason } = error.toObject()

    return dispatch(onGetTaxesKeyUserError({ backup, reason }))
  }
}

export const onSignInTaxesKeyThunk = payload => (_, getState) => {
  let registerWizardState = getState().registerWizard
  const taxesKeyURL = `${REACT_APP_API_BASE_URL}/v1/sii/clave-tributaria/authentication?csrf=${payload.csrfToken}&aplicativo=inscripcion-proveedor`

  if (payload.isRecovery) {
    registerWizardState = { ...registerWizardState, isRecoveryAdmin: true, isTaxesKey: true }
  }

  putCookie(
    'registerWizardBackup',
    { ...registerWizardState, business: { ...registerWizardState.business, dni: payload.dni } },
    { base64: true, json: true }
  )

  window.location.href = taxesKeyURL
}
